import { render, staticRenderFns } from "./blogs.vue?vue&type=template&id=612ca7b4&scoped=true&"
import script from "./blogs.vue?vue&type=script&lang=js&"
export * from "./blogs.vue?vue&type=script&lang=js&"
import style0 from "@/assets/main.css?vue&type=style&index=0&id=612ca7b4&scoped=true&lang=css&"
import style1 from "./blogs.vue?vue&type=style&index=1&id=612ca7b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612ca7b4",
  null
  
)

export default component.exports